<template>
  <div class="history-list">
    <!-- <div class="h_tools">
      <a-form layout="inline">
        <a-form-item label="创建时间：">
          <a-range-picker
            :value="addDate"
            format="YYYY-MM-DD"
            class="date-input"
            @change="onChangeAddTime"
          />
        </a-form-item>
        <a-form-item label="完成时间：">
          <a-range-picker
            :value="finishDate"
            format="YYYY-MM-DD"
            class="date-input"
            @change="onChangeFinishTime"
          />
        </a-form-item>
        <a-form-item label="状态：">
          <a-select
            v-model="searchForm.style"
            placeholder="请选择"
            @change="handleChangeStatus"
          >
            <a-select-option :value="0">
              待配置对应关系
            </a-select-option>
            <a-select-option :value="1">
              进行中
            </a-select-option>
            <a-select-option :value="1">
              完成
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            @click="onSearch"
          >
            查询
          </a-button>
          <a-button @click="onReset">
            重置
          </a-button>
        </a-form-item>
      </a-form>
    </div> -->
    <a-table
      v-if="!loading"
      row-key="id"
      :columns="columns"
      :data-source="listDatas"
      :pagination="false"
      :locale="{
        'emptyText': emptyTip
      }"
      @change="handleTableChange"
    >
      <template
        slot="addtime"
        slot-scope="text"
        class="time-item"
      >
        <p class="date">
          {{ $moment(text * 1000).format('YYYY-MM-DD') }}
        </p>
        <p class="time">
          {{ $moment(text * 1000).format('HH:mm:ss') }}
        </p>
      </template>
      <template
        slot="finishtime"
        slot-scope="text"
      >
        <template
          v-if="text"
          class="time-item"
        >
          <p class="date">
            {{ $moment(text * 1000).format('YYYY-MM-DD') }}
          </p>
          <p class="time">
            {{ $moment(text * 1000).format('HH:mm:ss') }}
          </p>
        </template>
        <template v-else>
          --
        </template>
      </template>
      <span
        slot="failTitle"
        class="fs-bold"
      > {{ $t('message["193"]') }}
        <a-tooltip
          placement="top"
          overlay-class-name="prompt-tooltip"
        >
          <template slot="title">
            {{ $t('message["356"]') }}
          </template>
          <i
            class="iconfont iconicon-test34 fs-gray explain-btn"
          />
        </a-tooltip>
      </span>
      <template
        slot="status"
        slot-scope="text, record"
      >
        <span
          class="status-name"
          :class="{ 'fs-green': record.status === 3 }"
        >
          <span :class="['status_circle', statusClass(record)]" />
          {{ statusName(record) }}
        </span>
      </template>
      <template
        slot="successnum"
        slot-scope="text"
      >
        <span>{{ text }} {{ $t('message["1199"]') }}</span>
      </template>
      <template
        slot="failnum"
        slot-scope="text, record"
      >
        <span>{{ text }} {{ $t('message["1199"]') }}
          <a
            v-if="text > 0 && record.status === 3"
            class="fs-blue"
            @click="handleDownError(record)"
          >{{ $t('message["1304"]') }}</a></span>
      </template>
      <div
        slot="fileurl"
        slot-scope="text, record"
        class="operate-btn"
      >
        <a
          v-if="text"
          :href="text"
          class="fs-blue"
        >{{ $t('message["1530"]') }}</a>
        <a
          v-if="record.status === 1"
          @click="handleContinue(record)"
        >
          {{ $t('message["466"]') }}
        </a>
        <a
          v-if="record.status === 1"
          @click="handleDelete(record)"
        >
          {{ $t('message["962"]') }}
        </a>
      </div>
    </a-table>
    <a-spin
      v-else
      class="spin-fixed-center"
    />
    <a-button
      v-if="listDatas && listDatas.length === 0"
      type="primary"
      class="create-btn"
      @click="handleCreate"
    >
      {{ $t('message["594"]') }}
    </a-button>
    <!-- <pagination
        v-if="listDatas && listDatas.length"
        ref="pagination"
        :pagination="pagination"
        @change="handlePage"
      /> -->
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { apiDomain } from '@/lib/config'
// import Pagination from '@/components/pc/Pagination'

export default {
  components: {
    // Pagination
  },

  data () {
    return {
      addDate: null,
      finishDate: null
      /* searchForm: {
        addstarttime: '',
        addendtime: '',
        finishstarttime: '',
        finishendtime: '',
        status: ''
      } */
    }
  },

  computed: {
    ...mapState('config/batchImport', ['loading', 'listDatas', 'pagination', 'tableSort']),
    ...mapGetters('config/batchImport', ['columns']),
    tab () {
      return this.$route.query.tab || '1'
    },
    emptyTip () {
      return this.$t('message["1549"]')
    }
  },

  watch: {
    tab (val) {
      if (val === '1') {
        this.fetchImportList()
      }
    },
    $route (to, from) {
      this.getList()
    }
  },

  created () {
    this.getList()
  },

  methods: {
    ...mapActions('config/batchImport', ['fetchImportList', 'deleteBulkImport']),
    ...mapMutations('config/batchImport', ['SET_TABLE_SORT']),

    getList (params = {}) {
      let tableSort = this.tableSort
      'sortkey' in tableSort && Object.assign(params, { sortkey: tableSort.sortkey })
      'sorttype' in tableSort && Object.assign(params, { sorttype: tableSort.sorttype })
      this.fetchImportList(params)
      window.scrollTo(0, 0)
    },
    /* onChangeAddTime (date, dateString) {
      this.searchForm.addstarttime = dateString[0]
      this.searchForm.addendtime = dateString[0]
    },
    onChangeFinishTime (date, dateString) {
      this.searchForm.finishstarttime = dateString[0]
      this.searchForm.finishendtime = dateString[0]
    },
    handleChangeStatus (val) {
      this.searchForm.status = val
    },

    onSearch () {
      this.pagination.currentPage = 1
      this.fetchList({
        ...this.searchForm,
        page: 1
      })
    },

    onReset () {
      this.clearSearchForm()
      this.onSearch()
    },

    clearSearchForm () {
      this.addDate = null
      this.finishDate = null
      this.searchForm = {
        status: '',
        addstarttime: '',
        addendtime: '',
        finishstarttime: '',
        finishendtime: ''
      }
    },

    handlePage (pagination) {
      this.fetchList({ ...this.searchForm, page: pagination.currentPage })
      this.pagination.currentPage = pagination.currentPage
      this.$router.push({
        name: 'configImportList',
        query: {
          ...this.$route.query,
          page: pagination.currentPage
        }
      })
    }, */

    handleTableChange (pagination, filters, sorter) {
      // console.log(sorter)
      const { order, columnKey } = sorter
      let tableSort = {}
      if (sorter.order) {
        let sort = 0
        if (order === 'ascend') {
          sort = 1 // 正序
        } else if (order === 'descend') {
          sort = 2 // 倒序
        } else {
          sort = 0
        }

        tableSort = {
          sortkey: (columnKey === 'addtime' || columnKey === 'taskid') ? 'id' : columnKey,
          sorttype: sort
        }
        this.SET_TABLE_SORT({ tableSort, sorter })
      } else {
        tableSort = {
          sortkey: undefined,
          sorttype: undefined
        }
        this.SET_TABLE_SORT({ tableSort: {}, sorter: {} })
      }
      this.$router.push({
        name: 'configImportList',
        query: {
          ...tableSort
        }
      })
    },

    statusClass (record) {
      let color
      switch (record.status) {
        case 1:
          color = 'bg-gray'
          break
        case 2:
          color = 'bg-blue'
          break
        case 3:
          color = 'bg-green'
          break
        default:
          color = 'bg-gray'
          break
      }
      return color
    },

    statusName (record) {
      let name
      switch (record.status) {
        case 1:
          name = this.$t('message["141"]')
          break
        case 2:
          name = this.$t('message["536"]')
          break
        case 3:
          name = this.$t('message["195"]')
          break
        case 7:
          name = this.$t('message["962"]')
          break
      }
      return name
    },

    handleDownError (record) {
      let url = `${apiDomain}/inquiry/bulkimport/exportError?id=${record.errorFileUrlId}`
      this.$windowOpen(url)
    },

    handleContinue (record) {
      let count = Number(record.status)
      let routeName
      switch (count + 1) {
        /* case 1:
          routeName = 'configImportFirst'
          break */
        case 2:
          routeName = 'configImportSecond'
          break
        case 3:
          routeName = 'configImportFinish'
          break
      }
      this.$router.push({
        name: routeName,
        query: {
          id: record.id
        }
      })
    },
    handleDelete (record) {
      let _this = this
      this.$confirm({
        title: this.$t('message["917"]') + '？',
        iconType: 'info-circle',
        closable: true,
        onOk () {
          _this.deleteBulkImport({
            id: record.id
          })
        },
        onCancel () {}
      })
    },

    handleCreate () {
      this.$router.push({
        name: 'configImportFirst'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .h_tools {
    padding: 10px 0;
  }
  .ant-select {
    width: 100px;
  }
  .status_circle {
    display: inline-block;
    width: 4px;
    height: 4px;
    margin-right: 4px;
    vertical-align: middle;
    border-radius: 4px;
  }
  .status-name {
    display: inline-block;
    padding: 4px;
    line-height: 1;
    font-size: 12px;
    border: solid 1px #EBEBEB;
    border-radius: 4px;
  }
  .bg-green {
    background-color: #42c27e;
  }
  .bg-blue {
    background-color:#5077aa;
  }
  .bg-gray {
    background-color: #b3b3b3;
  }
  .time-item {
    font-size: 12px;
    position: absolute;
    top: 8px;
    line-height: 16px;
    .time {
      color: #999;
    }
  }
  .operate-btn {
    // text-align: center;
    margin-left: -10px;
    a {
      padding: 0 10px;
    }
  }
  .create-btn {
    display: block;
    width: 80px;
    margin: 0 auto;
    font-size: 14px;
  }
</style>

<style lang="scss">
.history-list {
  .ant-table-thead > tr > th, .ant-table-tbody > tr > td {
    padding: 12px 6px !important;
  }
  .date-input .ant-input {
    width: 200px !important;
  }
  .prompt-tooltip {
    min-width: 200px;
    max-width: 400px;
    .ant-tooltip-inner {
      color: $gray3;
      min-width: 200px;
      max-width: 400px;
    }
    .ant-tooltip-content:after {
      content: "";
      position: absolute;
      width: 0;
      height: 0;
      left: 50%;
      margin-left: -7px;
      border-width: 7px 7px 0px 7px;
      border-color: transparent;
      border-top-color: #ebebeb;
      border-style: solid;
    }
    &.ant-tooltip-placement-top {
      .ant-tooltip-arrow {
        bottom: -4px !important;
        z-index: 2;
        border-top-color: #fff !important;
      }
    }
  }
}
</style>
